// extracted by mini-css-extract-plugin
export var errorIcon = "_lc-1";
export var nameLogo = "_lc-0";